"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const popover_1 = require("components/cosmos/v2/popover");
const translate_1 = require("components/translate");
const xIconCloseButton_1 = require("components/xIconCloseButton");
const manageCoverPopover_module_scss_1 = __importDefault(require("./manageCoverPopover.module.scss"));
const ManageCoverPopover = ({ t, isOpen, onClose, showOnboarding }) => {
    if (!showOnboarding || !isOpen) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(popover_1.Popover, { className: (0, classnames_1.default)(manageCoverPopover_module_scss_1.default.ManageCoverPopover, '_cursor-default'), position: "top", autoShow: true, children: [(0, jsx_runtime_1.jsxs)(popover_1.Popover.Header, { className: "_d-flex _justify-content-between", children: [(0, jsx_runtime_1.jsx)("h5", { className: "_text-2 _text-gray-500 _mb-0", children: t('content_list.cover_onboarding_title') }), (0, jsx_runtime_1.jsx)(xIconCloseButton_1.XIconCloseButton, { onClick: onClose, iconClassName: "_text-2 _text-gray-400 _cursor-pointer" })] }), (0, jsx_runtime_1.jsx)(popover_1.Popover.Body, { className: "_pt-0", children: t('content_list.cover_onboarding_description') })] }));
};
exports.default = (0, translate_1.translate)()(ManageCoverPopover);
